import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { memberMove } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        number: '',
        to_number: ''
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      memberMove({
        number: this.form.number,
        to_number: this.form.to_number
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$message({
                  message: '点位移动成功',
                  type: 'success'
                });

                _this.dialogVisible = false;

                _this.finish();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};